export default "__VITE_ASSET__CeIZbo8Z__"